import React from "react";

/**
 * A commission's state, as a pill. Three states and only three (contract §7): there is
 * deliberately NO `paid` — payment is the Gateway Wallet's withdrawal rail and its own
 * state machine, and a second collection claiming to know whether money left is the v0
 * defect this module replaces.
 *
 * `partially_reversed` and `reversed` must not read alike either: one still owes the
 * affiliate a remainder, the other owes nothing.
 *
 * PRESENTATIONAL — the caller resolves `label`, which is why the practitioner's plane
 * (`aff.state.*`) and the operator's (`saff.state.*`) share one component instead of two
 * copies of the same colour table.
 */
const STYLES = {
  accrued: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_reversed: "bg-amber-50 text-amber-800 border-amber-200",
  reversed: "bg-rose-50 text-rose-700 border-rose-200",
};

export default function CommissionStatusBadge({ status, label, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded-full border ${
        STYLES[status] || "bg-slate-50 text-slate-600 border-slate-200"
      }`}
    >
      {label}
    </span>
  );
}
